document.addEventListener('DOMContentLoaded', function () {

  function render_html(sort_by) {
    const container = document.querySelector('.product-list--collection');
    if (!container) return;

    const children = Array.from(container.querySelectorAll('.product-item'));

    if (sort_by === 'title-ascending') {
      children.sort((a, b) => {
        const nameA = a.getAttribute('product_title')?.toLowerCase() || '';
        const nameB = b.getAttribute('product_title')?.toLowerCase() || '';
        return nameA.localeCompare(nameB);
      });
    } else if (sort_by === 'title-descending') {
      children.sort((a, b) => {
        const nameA = a.getAttribute('product_title')?.toLowerCase() || '';
        const nameB = b.getAttribute('product_title')?.toLowerCase() || '';
        return nameB.localeCompare(nameA);
      });
    } else if (sort_by === 'price-ascending') {
      children.sort((a, b) => {
        const priceA = parseInt(a.getAttribute('product_price')) || 0;
        const priceB = parseInt(b.getAttribute('product_price')) || 0;
        return priceA - priceB;
      });
    } else if (sort_by === 'price-descending') {
      children.sort((a, b) => {
        const priceA = parseInt(a.getAttribute('product_price')) || 0;
        const priceB = parseInt(b.getAttribute('product_price')) || 0;
        return priceB - priceA;
      });
    } else if (sort_by === 'created-ascending') {
      children.sort((a, b) => {
        const dateA = new Date(a.getAttribute('product_created'));
        const dateB = new Date(b.getAttribute('product_created'));
        return dateA - dateB; // Oldest to Newest
      });
    } else if (sort_by === 'created-descending') {
      children.sort((a, b) => {
        const dateA = new Date(a.getAttribute('product_created'));
        const dateB = new Date(b.getAttribute('product_created'));
        return dateB - dateA; // Newest to Oldest
      });
    }

    // Re-append sorted items to the container
    children.forEach(child => container.appendChild(child));
  }

  const targetNode = document.querySelector('.collection__dynamic-part');
  if (targetNode) {
    const observer = new MutationObserver(function(mutationsList, observer) {
      const selectedSort = document.querySelector('#sort-by-selector .value-picker__choice-item.is-selected');
      const sort_by = selectedSort?.getAttribute('data-value');
      render_html(sort_by);
    });

    observer.observe(targetNode, {
      childList: true,
    });
  }

  const selectedSort = document.querySelector('#sort-by-selector .value-picker__choice-item.is-selected');
  const sort_by = selectedSort?.getAttribute('data-value');
  render_html(sort_by);  

});

// document.addEventListener('DOMContentLoaded', function () {

//   function render_html(sort_by) {
//         const container = document.querySelector('.product-list--collection');
//         if (!container) return;

//         const children = Array.from(container.querySelectorAll('.product-item'));
    
//         if (sort_by === 'title-ascending') {
//           children.sort((a, b) => {
//             const nameA = a.getAttribute('product_title')?.toLowerCase() || '';
//             const nameB = b.getAttribute('product_title')?.toLowerCase() || '';
//             return nameA.localeCompare(nameB);
//           });
//         } else if (sort_by === 'title-descending') {
//           children.sort((a, b) => {
//             const nameA = a.getAttribute('product_title')?.toLowerCase() || '';
//             const nameB = b.getAttribute('product_title')?.toLowerCase() || '';
//             return nameB.localeCompare(nameA);
//           });
//         } else if (sort_by === 'price-ascending') {
//           children.sort((a, b) => {
//             const priceA = parseInt(a.getAttribute('product_price')) || 0;
//             const priceB = parseInt(b.getAttribute('product_price')) || 0;
//             return priceA - priceB;
//           });
//         } else if (sort_by === 'price-descending') {
//           children.sort((a, b) => {
//             const priceA = parseInt(a.getAttribute('product_price')) || 0;
//             const priceB = parseInt(b.getAttribute('product_price')) || 0;
//             return priceB - priceA;
//           });
//         }

//         // Re-append sorted items to the container
//         children.forEach(child => container.appendChild(child));
//   }

//     const targetNode = document.querySelector('.collection__dynamic-part');
//     if (targetNode) {
//     const observer = new MutationObserver(function(mutationsList, observer) {
//       const selectedSort = document.querySelector('#sort-by-selector .value-picker__choice-item.is-selected');
//       const sort_by = selectedSort?.getAttribute('data-value');
//       render_html(sort_by);
//     });

//     observer.observe(targetNode, {
//       childList: true,
//     });
//   }

//   const selectedSort = document.querySelector('#sort-by-selector .value-picker__choice-item.is-selected');
//   const sort_by = selectedSort?.getAttribute('data-value');
//   render_html(sort_by);  
  
// });

